export default __webpack_public_path__ + "static/media/cow.5686545d.svg";